import type { PaymentAdapterClient } from '@payloadcms/plugin-ecommerce/types'

/**
 * Bank Transfer Client Adapter
 * Used on the client side to register the bank transfer payment method
 */
export const bankTransferAdapterClient: PaymentAdapterClient = {
  name: 'bankTransfer',
  label: 'Bank Transfer',
  confirmOrder: true,
  initiatePayment: true,
}

/**
 * Cash Envelope Client Adapter
 * Used on the client side to register the cash envelope payment method
 */
export const cashEnvelopeAdapterClient: PaymentAdapterClient = {
  name: 'cashEnvelope',
  label: 'Cash Envelope',
  confirmOrder: true,
  initiatePayment: true,
}

/**
 * Pickup in Store Client Adapter
 * Used on the client side to register the pickup payment method
 */
export const pickupAdapterClient: PaymentAdapterClient = {
  name: 'pickup',
  label: 'Pickup in Store',
  confirmOrder: true,
  initiatePayment: true,
}
